export const TRANSLATION_KEYS = {
    Heading: "common.webchat.solutionModal.heading",
    SecondaryHeading: "common.webchat.solutionModal.secondaryHeading",
    ColumnPreviewTooltip: "solutionPage.columnPreviewTooltip",
    ColumnTitleLabel: "solutionPage.columnTitleLabel",
    ColumnDepartmentLabel: "solutionPage.columnDepartmentLabel",
    ColumnCreatedAtLabel: "solutionPage.columnCreatedAtLabel",
    ColumnActionCommandAddTooltip: "common.webchat.solutionModal.columnActionCommandAddTooltip",
    DetailsListEmptyContentLabel: "solutionPage.detailsListEmptyContentLabel"
};